<div class="otp-container">
  @if (label) {
    <ion-label>{{ label }}</ion-label>
  }

  <ng-otp-input
      [config]="config"
      [formControl]="control">
  </ng-otp-input>
</div>
